export const SITE_CONFIG = {
  phone: "(02) 6106 9977",
  address: "Suite 2, 42 Geils Ct, Deakin ACT 2600 (Inside Canberra Hypnotherapy Clinic)",
  bookingUrl: "https://cbrhealthcare.bookings.pracsuite.com/guest?l=2278",
  logo: "https://media-manager-c.questera.ai/greta-media/388b1ab148d242655c048137613aa2bb6657adf5ebb8c647cad863997bd04ba744fbeb8b80e3364ef13bb85060475943/images/aW1hZ2UvcG5n/df321f8eaeceb9000d36bd5dcc402f01.png",
  chiropracticBrand: "Canberra City Chiropractic",
  tagline: "Serving Canberra since 1976",
  pricingNote: "Effective 1 July 2026. In-clinic services are priced as shown below.",
  cancellationPolicy: "Full price fees may apply if less than 24 hours notice is given to cancel or reschedule appointments.",
  disclaimer: "Individual results may vary. A thorough assessment is required to determine suitability for care.",
  openingHours: [
    { day: "Monday", hours: "8:30am - 12:00pm" },
    { day: "Tuesday", hours: "8:30am - 12:00pm" },
    { day: "Wednesday", hours: "Closed" },
    { day: "Thursday", hours: "8:30am - 12:00pm" },
    { day: "Friday", hours: "2:00pm - 6:00pm" },
    { day: "Weekends", hours: "Closed" }
  ],
  prioritySuburbs: ["Deakin", "Yarralumla", "Hughes", "Curtin", "Forrest", "Red Hill", "Garran", "Lyons", "Phillip"],
  nearbySuburbs: ["Griffith", "Barton", "Kingston", "Narrabundah", "O’Malley", "Chifley", "Canberra City", "Braddon", "Reid", "Turner", "Parkes", "Manuka"]
};

export const homeContent = {
  hero: {
    title: "Chiropractic care in Deakin, Canberra",
    subtitle: "Personalised assessment and chiropractic care for back pain, neck pain, headaches and other musculoskeletal concerns.",
    tagline: "Serving Canberra since 1976",
    description: "We take the time to understand your symptoms, explain what we find and discuss care options suited to your individual needs and goals.",
    image: "https://media-manager-c.questera.ai/greta-media/388b1ab148d242655c048137613aa2bb6657adf5ebb8c647cad863997bd04ba744fbeb8b80e3364ef13bb85060475943/images/aW1hZ2UvanBlZw==/635654608a574a2eefbd5e8f5d2743ba.jpg",
    features: [
      { title: "Thorough assessment", text: "We take time to understand your symptoms, health history and how the problem is affecting your life." },
      { title: "Personalised care", text: "Care recommendations are based on your individual presentation, needs and goals." },
      { title: "Clear explanations", text: "We'll explain what we find and discuss your options so you can make informed decisions." },
      { title: "Practical management", text: "Depending on your presentation, care may include manual therapy, exercise and movement advice." }
    ]
  },
  approach: {
    title: "Our approach to chiropractic care",
    description: "No two people presenting with back pain, neck pain or headaches are exactly alike. We consider your symptoms, health history, examination findings, lifestyle and goals when discussing your care.",
    description2: "Depending on your presentation, chiropractic management may include manual therapy, exercise, movement advice, education and strategies you can use between appointments.",
    description3: "If chiropractic care isn't appropriate for your presentation, we'll explain this and discuss other options, including referral to another healthcare provider when appropriate."
  },
  firstVisit: {
    title: "What to expect at your first appointment",
    steps: [
      { title: "We listen", text: "Tell us what's been happening, how your symptoms are affecting you and what you'd like to get back to doing." },
      { title: "We assess", text: "Your chiropractor will take a health history and perform an examination appropriate to your presentation." },
      { title: "We explain", text: "We'll discuss what we find, answer your questions and explain the options available to you." },
      { title: "We make a plan together", text: "If chiropractic care is appropriate, we'll discuss a management approach based on your individual needs and goals." }
    ]
  },
  policy: {
    title: "Not sure whether chiropractic is right for you?",
    text: "Our first priority is determining whether chiropractic care is appropriate for your presentation. If it isn't, we'll tell you and discuss suitable next steps.",
    subtext: "Our clinic policy means that no consultation fee applies where, following assessment, chiropractic care is considered not clinically appropriate. Conditions apply."
  },
  team: [
    {
      name: "Dr Louise Hughes",
      role: "Chiropractor",
      experience: "B.App.Sc (Chiro)",
      img: "https://mlqblpajbgqj.i.optimole.com/cb:-hzJ.4ecd8/w:214/h:160/q:mauto/dpr:1.5/g:sm/f:best/ig:avif/https://tuggeranongchiromassage.com.au/wp-content/uploads/2026/04/LouiseHughes.jpg"
    },
    {
      name: "Dr Nash Anderson",
      role: "Chiropractor",
      experience: "B.Sc (Chiro), B.Chiro",
      img: "https://mlqblpajbgqj.i.optimole.com/cb:-hzJ.4ecd8/w:180/h:240/q:mauto/dpr:1.5/g:sm/f:best/ig:avif/https://tuggeranongchiromassage.com.au/wp-content/uploads/2022/10/IMG_20190219_084323.jpg"
    }
  ],
  faqs: [
    {
      q: "What happens during the first appointment?",
      a: "The first visit is usually 45–60 minutes. We focus on understanding your health history and performing a thorough physical assessment."
    },
    {
      q: "Do I need a referral from my GP?",
      a: "In most cases, no. You can book directly with us as a private patient. Referrals are necessary for DVA, WorkCover, or Chronic Disease Management plans."
    },
    {
      q: "Can I claim my visit through private health insurance?",
      a: "Yes. We have HICAPS on-site, allowing you to claim your rebate immediately after your appointment."
    }
  ]
};

export const servicesData = {
  'back-pain': {
    title: 'Chiropractic Care for Back Pain',
    heroImage: 'https://media-manager-c.questera.ai/greta-media/388b1ab148d242655c048137613aa2bb6657adf5ebb8c647cad863997bd04ba744fbeb8b80e3364ef13bb85060475943/images/aW1hZ2UvanBlZw==/4a287b402b865b8fa5b6bfd303f5e8fb.jpg',
    description: 'Back pain can affect almost every part of daily life—from getting out of bed and sitting at work to lifting, exercising, sleeping or looking after your family. Our chiropractors take the time to understand your symptoms, how they are affecting you and what you would like to return to doing.',
    benefits: ['Thorough assessment', 'Manual therapy options', 'Movement advice', 'Ergonomic guidance'],
    pricing: {
      'New Patient Consultation': "$195.00",
      'Subsequent Visit': "$115.00"
    },
    detailedSections: [
      {
        title: "Can chiropractic care help with back pain?",
        content: "Chiropractic care can be a useful conservative treatment option for many people with back pain. Spinal manipulation is included as a treatment option in major evidence-based guidelines, generally as part of a broader approach that may also include education, exercise and support to remain active. Care is not the same for everyone. Your chiropractor will consider your symptoms, health history, examination findings, preferences and response to treatment when recommending an approach."
      },
      {
        title: "Back pain concerns we commonly assess",
        isList: true,
        listItems: [
          "New or recurrent lower-back pain",
          "Back stiffness or restricted movement",
          "Pain associated with sitting, standing or sustained positions",
          "Discomfort following lifting, gardening or physical work",
          "Back pain after increasing exercise or training",
          "Pain affecting sleep or everyday activities",
          "Buttock, hip or referred leg discomfort",
          "Sciatica or other nerve-related symptoms",
          "Persistent back pain that has not fully settled"
        ]
      },
      {
        title: "How may chiropractic treatment help?",
        isList: true,
        listItems: [
          "Chiropractic adjustments: Controlled manual techniques applied to appropriate areas of the spine.",
          "Joint mobilisation: Gentler, repeated movements used to improve comfort and mobility.",
          "Soft-tissue treatment: Hands-on care directed towards muscles and other soft tissues.",
          "Exercise and rehabilitation: Individual plans to develop mobility, strength, and confidence.",
          "Activity advice: Practical ways to manage work, lifting, and temporarily aggravating activities.",
          "Self-management strategies: Steps you can use between appointments to support progress."
        ]
      },
      {
        title: "What happens at your first appointment?",
        isList: true,
        listItems: [
          "History: We discuss your back pain, health history, and goals.",
          "Movement Assessment: Evaluating lower-back and hip movement.",
          "Palpation: Identifying areas of tenderness, stiffness or restricted movement.",
          "Functional Testing: Assessing bending, squatting, and physical control.",
          "Neurological Exam: Testing reflexes, strength and sensation when relevant."
        ]
      },
      {
        title: "A practical, evidence-informed approach",
        content: "Back pain is often influenced by a combination of joint and muscle function, physical workload, previous injury, general health, sleep, stress and sensitivity of the pain system. Evidence-based management commonly includes remaining active, exercise, education and selected physical treatments such as spinal manipulation. Chiropractic care can bring these elements together in a plan tailored to your symptoms, goals and lifestyle."
      },
      {
        title: "Will I need an X-ray or scan?",
        content: "Most people with uncomplicated back pain do not require imaging before beginning conservative care. If your history or examination suggests that an X-ray, MRI, CT or another investigation may assist your diagnosis or management, your chiropractor can explain why it is being considered and discuss the appropriate imaging or referral options."
      }
    ],
    faqs: [
      {
        q: "Does my back have to be adjusted?",
        a: "No. Chiropractic adjustments are one option. Care may also include mobilisation, soft-tissue treatment, exercise, activity advice or referral. Your options will be explained before care begins."
      },
      {
        q: "Is my back “out”?",
        a: "Back pain is rarely as simple as a bone being out of place. It involves joints, muscles, nerves, and physical load. Treatment aims to improve movement and function rather than repeatedly “putting the spine back in place”."
      },
      {
        q: "Should I remain active with back pain?",
        a: "For most uncomplicated back pain, continuing comfortable activity is generally preferable to prolonged bed rest. You may need to temporarily modify certain tasks, which your chiropractor can help with."
      },
      {
        q: "Can chiropractic care be combined with other healthcare?",
        a: "Yes. Chiropractic care can be provided alongside treatment from your GP, physiotherapist, massage therapist or other professionals. We can communicate with your other providers for coordinated care."
      }
    ],
    emergencyWarning: {
      title: "Important Medical Disclaimer",
      content: "This information is general and does not replace individual healthcare advice. Seek urgent medical attention for back pain accompanied by new loss of bladder or bowel control, numbness around the groin or buttocks, rapidly worsening leg weakness, significant trauma or feeling seriously unwell. Call 000 in an emergency."
    },
    references: [
      "Australian Commission on Safety and Quality in Health Care. Low Back Pain Clinical Care Standard. Sydney: ACSQHC; 2022. <a href='https://www.safetyandquality.gov.au/standards-and-frameworks/clinical-care-standards/low-back-pain-clinical-care-standard' target='_blank'>View</a>",
      "World Health Organization. WHO guideline for non-surgical management of chronic primary low back pain. Geneva: WHO; 2023. <a href='https://www.who.int/publications/i/item/9789240081789' target='_blank'>View</a>",
      "Rubinstein SM, et al. Benefits and harms of spinal manipulative therapy for the treatment of chronic low back pain. BMJ. 2019. <a href='https://www.bmj.com/content/364/bmj.l689' target='_blank'>View</a>",
      "George SZ, et al. Interventions for the management of acute and chronic low back pain: revision 2021. J Orthop Sports Phys Ther. 2021. <a href='https://doi.org/10.2519/jospt.2021.0304' target='_blank'>View</a>",
      "Hayden JA, et al. Exercise therapy for chronic low back pain. Cochrane Database Syst Rev. 2021. <a href='https://pubmed.ncbi.nlm.nih.gov/34580864/' target='_blank'>View</a>"
    ]
  },
  'neck-pain': {
    title: 'Neck Pain',
    heroImage: 'https://media-manager-c.questera.ai/greta-media/388b1ab148d242655c048137613aa2bb6657adf5ebb8c647cad863997bd04ba744fbeb8b80e3364ef13bb85060475943/images/aW1hZ2UvanBlZw==/107f2c607437a68c049f37634fb4963c.jpg',
    description: 'Neck pain can make everyday activities uncomfortable—from turning your head while driving to working, exercising or getting a good night’s sleep. At Canberra City Chiropractic, our chiropractors assess how your neck is moving, discuss what may be contributing to your symptoms and develop a care plan around your needs. Depending on your presentation, care may combine hands-on treatment, practical advice and exercise.',
    benefits: ['Joint mobilisation', 'Chiropractic adjustments', 'Soft-tissue treatment', 'Exercise & practical advice'],
    pricing: {
      'New Patient Consultation': "$195.00",
      'Subsequent Visit': "$115.00"
    },
    detailedSections: [
      {
        title: "Can chiropractic care help with neck pain?",
        content: "Chiropractors are registered health practitioners trained to assess and manage musculoskeletal conditions, including many common forms of neck pain. For some adults with non-specific neck pain, combining manual therapy with exercise may reduce pain and disability, particularly in the short term. Exercise can also help improve movement, strength and confidence using the neck. Chiropractic care is not the same for everyone. Your treatment will depend on your symptoms, examination findings, preferences and response to care."
      },
      {
        title: "Neck pain presentations we commonly assess",
        isList: true,
        listItems: [
          "A sore, stiff or difficult-to-move neck",
          "Recurrent neck aches",
          "Discomfort associated with desk work or sustained positions",
          "Pain after a change in exercise, workload or activity",
          "Difficulty turning the head while driving",
          "Neck and upper-back muscle tension",
          "Headaches that may be associated with the neck",
          "Neck pain accompanied by shoulder or arm symptoms"
        ]
      },
      {
        title: "What might chiropractic treatment include?",
        content: "Your care may include a combination of joint mobilisation (gentle, repeated movement), chiropractic adjustments (controlled manual techniques), soft-tissue treatment, individual exercises, practical advice, and self-management strategies. An adjustment is only one treatment option. You do not have to have your neck manipulated, and your chiropractor can discuss alternative approaches."
      },
      {
        title: "What happens at the first appointment?",
        content: "Your chiropractor will begin by asking about your symptoms, health history, previous injuries, daily activities and what you would like to improve. The examination may assess neck and upper-back movement, areas of tenderness or stiffness, muscle strength, shoulder movement, and reflexes when relevant. Your chiropractor will then explain the likely nature of your neck pain and discuss suitable options."
      },
      {
        title: "An individual and evidence-informed approach",
        content: "Research does not identify one technique that is best for every person with neck pain. Current evidence supports matching care to the individual and commonly combining manual treatment with exercise and advice. We monitor your progress and adjust the plan according to changes in pain, movement and everyday activity. Outcomes vary, and no particular result can be guaranteed."
      },
      {
        title: "Will I need an X-ray?",
        content: "Most people with uncomplicated neck pain do not require an X-ray before beginning care. Canberra City Chiropractic has X-ray facilities nearby in Deakin with Canberra Imaging and I-med when imaging is clinically indicated and likely to assist diagnosis or management. If another investigation, such as MRI or CT, would be more appropriate, your chiropractor can discuss the relevant referral options."
      }
    ],
    faqs: [
      {
        q: "Does my neck have to be “cracked”?",
        a: "No. Some patients choose chiropractic adjustments, while others prefer mobilisation, soft-tissue treatment, exercise or a combination of approaches. Treatment choices are discussed with you before care begins."
      },
      {
        q: "Is the clicking sound important?",
        a: "A clicking or popping sound can occur when pressure changes within a joint. A sound is not required for treatment to be useful and does not show that a joint has been “put back into place”."
      },
      {
        q: "How many appointments will I need?",
        a: "There is no standard schedule that suits everyone. Recommendations depend on your symptoms, goals and response to care. Your progress should be reviewed rather than assuming that ongoing treatment is always required."
      },
      {
        q: "Can my chiropractor work with my GP?",
        a: "Yes. With your consent, our chiropractors can communicate with your GP or another healthcare practitioner when coordinated care, medical assessment or further investigation would be helpful."
      }
    ],
    emergencyWarning: {
      title: "Important Medical Disclaimer",
      content: "This information is general and does not replace individual healthcare advice. Seek urgent medical attention for neck pain following significant trauma or neck pain accompanied by sudden weakness, facial drooping, difficulty speaking, severe unsteadiness or other rapidly developing neurological symptoms. Call 000 in an emergency."
    },
    references: [
      "Reynolds B, McDevitt A, Kelly J, Mintken P, Clewley D. Manual physical therapy for neck disorders: an umbrella review. J Man Manip Ther. 2025;33(1):18–35. <a href='https://pmc.ncbi.nlm.nih.gov/articles/PMC11770850/' target='_blank' rel='noopener noreferrer' class='text-teal-600 hover:underline'>View</a>",
      "Minnucci S, Innocenti T, Salvioli S, et al. Benefits and harms of spinal manipulative therapy for treating recent and persistent nonspecific neck pain: a systematic review with meta-analysis. J Orthop Sports Phys Ther. 2023;53(9):510–528. <a href='https://doi.org/10.2519/jospt.2023.11708' target='_blank' rel='noopener noreferrer' class='text-teal-600 hover:underline'>View</a>",
      "Jones LB, Jadhakhan F, Falla D. The influence of exercise on pain, disability and quality of life in office workers with chronic neck pain: a systematic review and meta-analysis. Appl Ergon. 2024;117:104216. <a href='https://doi.org/10.1016/j.apergo.2023.104216' target='_blank' rel='noopener noreferrer' class='text-teal-600 hover:underline'>View</a>",
      "Blanpied PR, Gross AR, Elliott JM, et al. Neck pain: revision 2017. J Orthop Sports Phys Ther. 2017;47(7):A1–A83. <a href='https://doi.org/10.2519/jospt.2017.0302' target='_blank' rel='noopener noreferrer' class='text-teal-600 hover:underline'>View</a>",
      "Australian Health Practitioner Regulation Agency. Acceptable evidence in health advertising. <a href='https://www.ahpra.gov.au/Resources/Advertising-hub/Advertising-guidelines-and-other-guidance/Acceptable-evidence-in-health-advertising.aspx' target='_blank' rel='noopener noreferrer' class='text-teal-600 hover:underline'>View</a>"
    ]
  },
  'headaches-migraines': {
    title: 'Headaches & Migraine',
    heroImage: 'https://media-manager-c.questera.ai/greta-media/388b1ab148d242655c048137613aa2bb6657adf5ebb8c647cad863997bd04ba744fbeb8b80e3364ef13bb85060475943/images/aW1hZ2UvanBlZw==/acc11496f236d38f2abdc0dde48ed310.jpg',
    description: 'Headaches can interfere with concentration, work, sleep, exercise and time with family. They are also commonly experienced alongside neck pain, stiffness, muscle tension or restricted movement.',
    benefits: ['Assessment of neck causes', 'Manual therapy options', 'Posture advice', 'Exercise plans'],
    pricing: {
      'New Patient Consultation': "$195.00",
      'Subsequent Session': "$115.00"
    },
    detailedSections: [
      {
        title: "Can chiropractic care help with headaches?",
        content: "Chiropractic care may help some people with headaches that are related to the neck, particularly cervicogenic headaches. Research suggests that spinal manipulation, mobilisation and exercise may help reduce the frequency, intensity and impact of cervicogenic headaches for some patients. Manual therapy and exercise may also be useful for some people with tension-type headaches, especially when neck pain, stiffness or muscle tenderness is present."
      },
      {
        title: "Headache concerns we commonly assess",
        isList: true,
        listItems: [
          "Headaches that seem to begin in the neck or base of the skull",
          "Headaches accompanied by neck pain or stiffness",
          "Pain that travels from the back of the head towards the forehead or eye",
          "Headaches aggravated by neck movement or sustained positions",
          "Headaches associated with desk work, driving or physical workload",
          "Tension-type headaches with neck and shoulder discomfort",
          "Recurrent headaches associated with restricted neck movement",
          "Migraine accompanied by neck pain, stiffness or muscle tension",
          "Headaches following a previous neck injury"
        ]
      },
      {
        title: "What is a cervicogenic headache?",
        content: "A cervicogenic headache is a recognised headache disorder in which pain is attributed to a problem involving the neck. It often involves headache and neck pain occurring together, reduced or uncomfortable neck movement, and symptoms that travel towards the forehead, temple or eye."
      },
      {
        title: "How may chiropractic treatment help?",
        isList: true,
        listItems: [
          "Chiropractic adjustments: Controlled manual techniques applied to the neck or upper back.",
          "Joint mobilisation: Gentler movements used to improve comfort and mobility.",
          "Soft-tissue treatment: Hands-on care directed towards tight or tender muscles.",
          "Neck and shoulder exercises: Individual plans to improve mobility and strength.",
          "Work and activity advice: Practical strategies for desk work and aggravating activities.",
          "Headache self-management: Advice about movement, sleep, and monitoring patterns."
        ]
      },
      {
        title: "Chiropractic care and migraine-associated neck pain",
        content: "Migraine is a complex neurological condition, but many people with migraine also experience neck pain, stiffness or restricted movement. Chiropractic care may be used alongside your usual migraine management to address these associated musculoskeletal symptoms."
      },
      {
        title: "What happens at your first appointment?",
        content: "Your chiropractor will ask about your headache pattern, where it begins, and how it affects your life. Your examination may include neck and upper-back movement, muscle and joint function, posture and relevant neurological testing."
      }
    ],
    faqs: [
      {
        q: "Can a chiropractor help with migraines?",
        a: "Chiropractic care may be relevant for people with migraine who also experience neck pain, stiffness, muscle tenderness or restricted movement. Treatment is directed towards these musculoskeletal features."
      },
      {
        q: "Does my neck have to be adjusted?",
        a: "No. Treatment choices can include chiropractic adjustments, gentler mobilisation, upper-back treatment, soft-tissue techniques and exercise."
      },
      {
        q: "What is a migraine aura?",
        a: "Aura describes temporary neurological symptoms like visual disturbances or tingling. New or sudden neurological symptoms require urgent medical assessment."
      },
      {
        q: "Can massage help with headaches?",
        a: "Massage may assist some people whose headaches are accompanied by neck, shoulder or scalp muscle tension. We work alongside other practitioners to coordinate care when appropriate."
      }
    ],
    emergencyWarning: {
      title: "When should a headache be assessed urgently?",
      content: "Call 000 for a sudden, extremely severe headache or a headache accompanied by new weakness, facial drooping, difficulty speaking, confusion, seizure, fainting or significant vision loss. Prompt medical assessment is also appropriate for a substantially changed headache."
    },
    references: [
      "Headache Classification Committee of the International Headache Society. Cervicogenic headache. <a href='https://ichd-3.org/11-headache-or-facial-pain-attributed-to-disorder-of-the-cranium-neck-eyes-ears-nose-sinuses-teeth-mouth-or-other-facial-or-cervical-structure/11-2-headache-attributed-to-disorder-of-the-neck/11-2-1-cervicogenic-headache/' target='_blank'>View</a>",
      "Bini P, et al. Effectiveness of manual and exercise therapy on headache intensity and frequency. Chiropr Man Therap. 2022. <a href='https://doi.org/10.1186/s12998-022-00459-9' target='_blank'>View</a>",
      "Fernandez M, et al. Spinal manipulation for the management of cervicogenic headache. Eur J Pain. 2020. <a href='https://pubmed.ncbi.nlm.nih.gov/32621321/' target='_blank'>View</a>",
      "Côté P, et al. Non-pharmacological management of persistent headaches associated with neck pain. Eur J Pain. 2019. <a href='https://pubmed.ncbi.nlm.nih.gov/30707486/' target='_blank'>View</a>",
      "Kamonseki DH, et al. Effectiveness of manual therapy in patients with tension-type headache. Disabil Rehabil. 2022. <a href='https://pubmed.ncbi.nlm.nih.gov/32924640/' target='_blank'>View</a>"
    ]
  },
  'myofascial-dry-needling': {
    title: 'Dry Needling',
    heroImage: 'https://media-manager-c.questera.ai/greta-media/388b1ab148d242655c048137613aa2bb6657adf5ebb8c647cad863997bd04ba744fbeb8b80e3364ef13bb85060475943/images/aW1hZ2UvanBlZw==/07e312ee7e437e9ae57e048220752b9c.jpg',
    description: 'Dry needling is a treatment used for some muscle and joint-related concerns. A trained practitioner inserts a fine, sterile, single-use needle into selected areas of muscle—without injecting medication.',
    benefits: ['Targeted muscle relief', 'Support for recovery', 'Improved local blood flow'],
    pricing: {
      'New Patient Consultation': "$195.00",
      'Subsequent Session': "$115.00"
    },
    detailedSections: [
      {
        title: "Dry needling for muscle pain and tension",
        content: "It may be considered when muscle tenderness, tightness or sensitivity is contributing to pain or making movement uncomfortable. Dry needling is commonly used as part of care for concerns involving the neck, shoulders, back, hips and limbs."
      },
      {
        title: "How may dry needling help?",
        content: "Research suggests dry needling may provide short-term pain relief for some musculoskeletal conditions. Its effects vary between people and conditions, so it is generally used as one part of a broader treatment plan involving manual therapy, exercise, and activity advice."
      },
      {
        title: "What does dry needling feel like?",
        content: "You may feel very little as the needle enters the skin. When the needle reaches a sensitive area, you may briefly experience an ache, cramp or muscle twitch. Temporary soreness or mild bruising can occur."
      },
      {
        title: "Is dry needling the same as acupuncture?",
        content: "While they use similar needles, dry needling is based on musculoskeletal assessment and directed towards particular muscles identified during your examination, rather than traditional acupuncture points."
      }
    ],
    references: [
      "Chys M, et al. Clinical effectiveness of dry needling in patients with musculoskeletal pain. J Clin Med. 2023. <a href='https://pmc.ncbi.nlm.nih.gov/articles/PMC9917679/' target='_blank'>View</a>",
      "Gattie E, et al. Effectiveness of trigger point dry needling for musculoskeletal conditions. J Orthop Sports Phys Ther. 2017. <a href='https://doi.org/10.2519/jospt.2017.7096' target='_blank'>View</a>",
      "Boyce D, et al. Adverse events associated with therapeutic dry needling. Int J Sports Phys Ther. 2020. <a href='https://pubmed.ncbi.nlm.nih.gov/32089962/' target='_blank'>View</a>"
    ]
  }
};

export const legalData = {
  'privacy-policy': {
    title: 'Privacy Policy',
    lastUpdated: 'August 2023',
    content: `Canberra City Chiropractic manages personal information in accordance with the Privacy Act 1988 (Cth). We are committed to protecting the confidentiality of your health records.`
  },
  'terms-of-service': {
    title: 'Terms of Service',
    lastUpdated: 'August 2023',
    content: `We provide a thorough New Patient Consultation to determine if chiropractic care is appropriate. If care is deemed not appropriate, there will be no charge for that assessment.`
  }
};